<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 9/9/2021
  -->

<template>
	<div>
		<div v-if="billingData.isHourly" class="mb-3">
			Hourly rate {{ currencyString }}
			<qw-input type="number" v-model.number="billingData.hourlyRate"
					  :inputDebounceDelay="200"
					  class="amount-width" @input="onHourlyRateChanged"/>
		</div>
		<div v-if="billingData.isHourly && !billingData.hourlyRate">
			<span class="text-warning">Please set your hourly rate above</span>
		</div>
		<div v-if="billingData.totalAmount() > 0 && !disableInvoices" class="mb-4 ">
			<div class="row mx-0">
				<span class="mr-3">Total: </span>{{ currencyString }}<span>{{ billingData.totalAmount() }}</span>
				<span class="text-success ml-2">({{ currencyFormatted(billingData.totalAmountPaid(invoices)) }} paid)</span>
				<div class="layout-spacer"></div>
				<SavingIndicator ref="saveIndicator" :visible="isSavingBillingData"/>
			</div>
			<div>
				<a href="#" class="" size="small" @click.prevent="onSendInvoiceClicked()">
					create invoice
				</a>
			</div>
		</div>

		<div class="mb-2 qwoach-form">
			<div v-for="(billingItem, index) in billingData.billingItemsByType()"
				 :key="index"
				 :invoice="invoice = findInvoiceGroupForBillingItemId(billingItem.id)"
				 :canEdit="canEdit = invoice == null">

				<div class=" hover show-on-hover-parent"
					 :class="{'pointer': !canEdit}">
					<div class="row mx-0">
						<div class="col px-0"
							 @click="findInvoiceGroupForBillingItemId(billingItem.id) ? onBillingItemRowClicked(billingItem) : null">
							<div v-if="billingData.isHourly">
								<div v-if="billingData.hourlyRate">

									{{ currencyString }}
									<qw-input type="number"
											  :readonly="!canEdit"
											  v-model.number="billingItem.amount"
											  :inputDebounceDelay="500"
											  class="amount-width d-inline pr-2"
											  :class="{'text-muted': !canEdit}"
											  @input="hourlyOnAmountChanged(billingItem)"/>

									<TimeEntryInput
										v-model="billingItem.durationMs"
										:readonly="!canEdit"
										placeholder="0:00"
										class="duration-width pr-2"
										:inputDebounceDelay="500"
										:class="{'text-muted': !canEdit}"
										@change="onTimeChanged(billingItem)"
									/>
									<i v-if="canEdit" class="fontello icon-pencil pointer mr-2"
									   @click="onTimeEntryEditClicked(billingItem)"></i>
									<span v-if="!invoice && billingItem.amount > 0 && !disableInvoices"><a href="#"
																										   class=""
																										   size="small"
																										   @click.prevent="onManualPaymentConfirmClicked(billingItem)">paid?</a></span>
									<span v-else-if="invoice">
										<span v-if="invoice.isPaid()" class="text-success">(Paid)</span>
										<span v-else-if="invoice.isInvoiced()" class="">(Invoiced)</span>
										<span v-else-if="invoice.isConfirmPending()"
											  class="text-warning">(Confirm)</span>
									</span>
								</div>

							</div>
							<div v-else>
								{{ currencyString }}<input type="number" :readonly="!canEdit"
														   v-model.number="billingItem.amount" class="amount-width"
														   :class="{'text-muted': !canEdit}" @input="onDataChanged">

								<el-dropdown ref="milestonePicker" @command="onMilestonePicked" trigger="click">
														  <span class="el-dropdown-link">
															  <span class="no-select" :class="{'pointer':canEdit}">
																  <span>
																	  <span v-if="billingItem.isDueDateSet()"
																			class="pr-2">{{ billingItem.name }}</span>
																	  <span v-else-if="canEdit"
																			class="pr-2">set due</span>
																	  <span v-else
																			class="pr-2">{{
																			  billingItem.paidOrInvoicedDateFormatted()
																		  }}</span>
																  </span>
																  <i v-if="canEdit"
																	 class="fontello icon-down-dir text-muted"/></span>
														  </span>
									<template #dropdown><el-dropdown-menu class="p-3"
													  :class="{'display-none' : !canEdit}">
										<el-tabs value="progress">
											<div style="max-height: 450px; overflow-y: auto;">
												<el-dropdown-item
													v-for="(section, indexStep) in programItem.programSteps"
													:key="indexStep"
													:disabled="isProgramStepAlreadyUsed(section)"
													:command="{command:'byProgress', itemId: billingItem.id, index: index, data:section.id, name:section.name}">
													{{ section.name }}
												</el-dropdown-item>
											</div>

											<!--												<el-tab-pane label="By progress" name="progress">-->
											<!--													<el-tab-pane label="By progress" name="progress">-->
											<!--													<div style="max-height: 450px; overflow-y: auto;">-->
											<!--														<el-dropdown-item-->
											<!--															v-for="(section, indexStep) in programItem.programSteps"-->
											<!--															:key="indexStep"-->
											<!--															:disabled="isProgramStepAlreadyUsed(section)"-->
											<!--															:command="{command:'byProgress', itemId: billingItem.id, index: index, data:section.id, name:section.name}">-->
											<!--															{{ section.name }}-->
											<!--														</el-dropdown-item>-->
											<!--													</div>-->

											<!--												</el-tab-pane>-->
											<!--												<el-tab-pane label="By date" name="date">-->
											<!--													<datepicker :inline="true" @selected="onMilestonePicked({command:'byDate', itemId: billingItem.id, index: index, data:$event} )"></datepicker>-->

											<!--												</el-tab-pane>-->
										</el-tabs>
									</el-dropdown-menu></template>
								</el-dropdown>
								<span v-if="!invoice && billingItem.amount > 0 && !disableInvoices"><a href="#"
																									   class=""
																									   size="small"
																									   @click.prevent="onManualPaymentConfirmClicked(billingItem)">paid?</a></span>
								<span v-else-if="invoice">
										<span v-if="invoice.isPaid()" class="text-success">(Paid)</span>
										<span v-else-if="invoice.isInvoiced()" class="">(Invoiced)</span>
										<span v-else-if="invoice.isConfirmPending()"
											  class="text-warning">(Confirm)</span>
									</span>

							</div>
						</div>
						<div v-if="canEdit">
							<i class="fontello icon-trash pointer "
							   @click="onDeleteMilestoneClicked(billingItem)"/>
						</div>
					</div>
				</div>
			</div>
		</div>

		<a v-if="!billingData.isHourly || billingData.hourlyRate" href="#" type="primary" size="small" plain
		   class="mt-3"
		   @click.prevent="onAddMilestoneClicked">
			<span v-if="billingData.isHourly">+ Add time entry</span>
			<span v-else>+ Add payment milestone
				</span>
		</a>
		<ToolTipView v-if="!billingData.isHourly" :analyticsProps="{label: 'Add payment milestone', ...analyticsPropsMethod()}" >
			Payment milestone defines when your client is required to pay during the coaching program and how much.
			<br/>
			<br/>
			When you add a payment milestone, your would assign it to a specific section of your program.
			<br/>
			<br/>
			Once assigned, access to the rest of the program will be locked for your client till they complete the payment.
			<br/>
			<br/>
			To request the whole price upfront, you can create a single milestone specifying the full amount and assigning it to the first section of your coaching program.
			<br/>
			<br/>
			You can also split the payment for your client by creating multiple payment milestones.
		</ToolTipView>
		<hr v-if="!hidePaymentMethodsView"/>
		<PaymentMethodsManageView
			v-if="!hidePaymentMethodsView"
			:modal="modal"
			:modalSize="modalSize"
			:analytics-props="analyticsPropsMethod()"
		/>
	</div>
</template>

<script>

import BasePaymentTypePanel from "@/core/modules/coach/Coaching/Panels/ProgramBilling/PaymentTypes/BasePaymentTypePanel.vue";
import SavingIndicator from "@/core/components/SavingIndicator.vue";
import {MilestoneType} from "@shared/Billing/BillingItem";
import moment from 'moment'
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
import PaymentMethodsManageView from "@/core/modules/coach/Coaching/Panels/ProgramBilling/PaymentMethodsManageView.vue";


export default {
	name: "FixedPaymentTypePanel",
	components: {PaymentMethodsManageView, ToolTipView, SavingIndicator},
	extends: BasePaymentTypePanel,

	methods: {
		onBillingItemRowClicked(billingItem, invoiceGroup) {
			console.log("onBillingItemRowClicked: billingItem = ", billingItem, ", invoiceGroup = ", invoiceGroup)
			invoiceGroup = invoiceGroup || this.findInvoiceGroupForBillingItemId(billingItem.id)
			if (invoiceGroup.isPaid()) {
				this.$parent.onConfirmedPaymentClicked(billingItem)
			} else if (invoiceGroup.isInvoiced() || invoiceGroup.isConfirmPending()) {
				this.$parent.onManualPaymentConfirmClicked(billingItem)
			}
		},
		onMilestonePicked(command) {

			console.log("onMilestonePicked: command = ", command)
			let itemId = command.itemId;
			let index = command.index
			let item = this.billingData.findBillingItemById(itemId);
			let milestonePicker = this.$refs.milestonePicker[index]
			switch (command.command) {
				case "byDate": {
					let date = moment(command.data)
					item.milestoneType = MilestoneType.DATE
					//order here matters to set the name correctly
					item.milestoneTs = date.valueOf()
					item.name = item.milestoneDateFormatted();
					break
				}
				case "byProgress": {
					item.milestoneType = MilestoneType.PROGRESS
					item.milestoneSectionId = command.data
					item.name = command.name;
					break
				}
			}

			milestonePicker.hide()
			this.onDataChanged()
		},
	},
}
</script>

<style lang="scss">

</style>
